<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    width="200"
    height="200"
    style="shape-rendering: auto; display: block; background: rgba(0, 100, 146, 0)"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <g transform="translate(80,50)">
        <g transform="rotate(0)">
          <circle class="loader-circle" fill-opacity="1" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.8177570093457943s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.8177570093457943s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,71.21320343559643)">
        <g transform="rotate(45)">
          <circle class="loader-circle" fill-opacity="0.875" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.7009345794392523s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.7009345794392523s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(50,80)">
        <g transform="rotate(90)">
          <circle class="loader-circle" fill-opacity="0.75" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.5841121495327103s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.5841121495327103s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.786796564403577,71.21320343559643)">
        <g transform="rotate(135)">
          <circle class="loader-circle" fill-opacity="0.625" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.4672897196261682s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.4672897196261682s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(20,50.00000000000001)">
        <g transform="rotate(180)">
          <circle class="loader-circle" fill-opacity="0.5" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.35046728971962615s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.35046728971962615s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(28.78679656440357,28.786796564403577)">
        <g transform="rotate(225)">
          <circle class="loader-circle" fill-opacity="0.375" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.2336448598130841s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.2336448598130841s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(49.99999999999999,20)">
        <g transform="rotate(270)">
          <circle class="loader-circle" fill-opacity="0.25" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="-0.11682242990654206s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="-0.11682242990654206s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g transform="translate(71.21320343559643,28.78679656440357)">
        <g transform="rotate(315)">
          <circle class="loader-circle" fill-opacity="0.125" fill="#ffd943" r="6" cy="0" cx="0">
            <animateTransform
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              values="1.5 1.5;1 1"
              begin="0s"
              type="scale"
              attributeName="transform"
            ></animateTransform>
            <animate
              begin="0s"
              values="1;0"
              repeatCount="indefinite"
              dur="0.9345794392523364s"
              keyTimes="0;1"
              attributeName="fill-opacity"
            ></animate>
          </circle>
        </g>
      </g>
      <g></g>
    </g>
    <!-- [ldio] generated by https://loading.io -->
  </svg>
</template>
<style scoped lang="scss">
.loader-circle {
  fill: rgb(var(--v-theme-buttonActive));
}
</style>
